import PortalLayout from "../../components/layouts/PortalLayout";

export default function Portal() {
  return (
    <PortalLayout>
      <></>
    </PortalLayout>
  );
}
